import React, { useContext, useEffect, useState } from "react";
import i18next from "i18next";
import { Radio } from "antd";
import { LanguageContext } from "../../../context/LanguageProvider";
import { languageData } from "../../../constants/data";
import { useDispatch } from "react-redux";
import { preferredLanguageApi } from "../../../redux/services/language/languageServices";
import { useTranslation } from "react-i18next";

const LanguageRadioGroup = ({ height, width }) => {
  const { selectedLanguage, setSelectedLanguage, updateLanguage } =
    useContext(LanguageContext);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();

  // Function to handle language change
  const handleChange = async (e) => {
    const value = e.target.value;

    await localStorage.setItem("i18nextLng", value);
    await updateLanguage(value);
    const dataToBeSent = {
      preferred_language: value,
    };
    dispatch(preferredLanguageApi(dataToBeSent, setLoading));

    // }
  };

  return (
    <Radio.Group
      onChange={handleChange}
      value={selectedLanguage.value}
      style={{ marginRight: 16 }}
    >
      {Object.keys(languageData).map((item, i) => (
        <Radio
          key={i}
          style={{ fontSize: 20 }}
          value={languageData[item]?.value}
        >
          {languageData[item]?.label}
        </Radio>
      ))}
    </Radio.Group>
  );
};

export default LanguageRadioGroup;
